export default (axios) => ({
  userCount() {
    const instance = axios.create();
    return instance.get("admin/user-count", {
      transformRequest: (data, headers) => {
        delete headers.common["Authorization"];
        return data;
      },
    });
  },
});
